let current = 0;
const slides = document.querySelectorAll(".js-SimpleGallery img");
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

if(slides.length > 1 && !isReduced) {
  slides[0].classList.add('is-active', 'is-transitioning');

  setInterval(function() {
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.remove('is-active', 'is-transitioning');
    }
  
    current = (current != slides.length - 1) ? current + 1 : 0;
    slides[current].classList.add('is-active', 'is-transitioning');
  }, 8000);
}
